export const defaultRoute = {name: 'PartnerList', params: {}};
